import * as mobx from 'node-modules-mobx';


export default mobx;
Object.assign(exports, mobx);

window.mobx = mobx;



// WEBPACK FOOTER //
// ./assets/es6/common/mobx.es6